/* loaded by smart-asset */
export default require("./close-24px~biZSXCqX.svg")